import React, { useState } from 'react';
import { database, storage, firebase } from '../Firebase/firebase';
import { Button, ProgressBar } from 'react-bootstrap';
import Avatar from 'react-avatar';
import { v4 as uuidv4 } from 'uuid';

import { firebaseCollections, postTypesArr, visibilityStatesArr } from '../Constants/Variables';
import { truncateString } from '../Constants/Functions';
import AppDropdown from './AppDropdown';
import RichTextEditor from './RichTextEditor';

import '../Styles/Components/AddNewPostForm.scss';


export default function AddNewPostForm(props) {

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState("");
    const [selectedFilePreviewImgURL, setSelectedFilePreviewImgURL] = useState(null);
    const [selectedFileLabel, setSelectedFileLabel] = useState(null);
    const [selectedPostType, setSelectedPostType] = useState(0);
    const [selectedPostVisibility, setSelectedPostVisibility] = useState(0);
    const [enteredPostText, setEnteredPostText] = useState("");

    var storageRef = storage.ref();
    var provider = props.provider;
    var account = provider.account;

    const onTypeSelect = selectedItemIndex => {
        setSelectedPostType(selectedItemIndex);
    }

    const onVisibilitySelect = selectedItemIndex => {
        setSelectedPostVisibility(selectedItemIndex);
    }

    const handleFormValidation = () => {
        return selectedPostType === 0 || enteredPostText.length === 0;
    }

    const handleFormSubmission = () => {
        var postId = uuidv4();
        var post = {
            id: postId,
            timestamp: new Date(),
            visibility: selectedPostVisibility,
            type: {
                index: selectedPostType - 1,
                name: postTypesArr[selectedPostType]
            },
            user: {
                uid: account.accountIdentifier,
                name: account.name
            },
            message: enteredPostText,
            likes: [],
            comments: []
        };
        setEnteredPostText("");
        setSelectedFile(null);
        setSelectedFileName("");
        setSelectedFileLabel(null);
        setSelectedFilePreviewImgURL(null);
        setSelectedPostType(0);
        setSelectedPostVisibility(0);

        //Add New Post Doc in Firebase
        database.collection(firebaseCollections.thewall).doc(postId).set(post)
            .then(function () {
                console.log("Finished adding a new feedback post to firebase db.");
            })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });

        //upload to storage if valid file has been selected
        if (selectedFile) {
            fileUploadHandler(postId)
        };
    }

    const selectFileHandler = () => {
        document.getElementById("AddNewPostForm--ImageUpload").click();
    }

    const removeFileSelectedHandler = () => {
        setSelectedFilePreviewImgURL(null);
        setSelectedFile(null);
        setSelectedFileLabel(null);
        setSelectedFileName("");
    }

    const fileSelectedOnChangeHandler = evt => {
        const fileUploaded = evt.target.files[0];
        if (fileUploaded) {
            const fileType = fileUploaded.type;
            const fileSize = fileUploaded.size;
            const fileSizeKBLimit = 5000;

            //check if file selected is supported for upload
            if (fileType === "image/jpeg" || fileType === "image/gif" || fileType === "image/png" || fileSize <= fileSizeKBLimit) {
                setSelectedFilePreviewImgURL(URL.createObjectURL(fileUploaded));
                setSelectedFile(fileUploaded);
                setSelectedFileName(fileUploaded.name);
                setSelectedFileLabel(
                    <span title={fileUploaded.name} className="AddNewPostForm--ImageUpload--SelectedFile-Label">
                        <img className="AddNewPostForm--ImageUpload--SelectedFile-Remove-Btn" src="/images/x_icon.png" alt="remove file button" onClick={removeFileSelectedHandler} />
                        {truncateString(fileUploaded.name, 20)}
                    </span>
                );
            } else {
                removeFileSelectedHandler();
                setSelectedFileLabel(<span className="AddNewPostForm--ImageUpload--SelectedFile-Label" style={{ color: 'red' }}>Sorry you can only upload up to 5MB in one of the following formats: .gif, png or jpeg</span>);
            }
        }
    }

    const fileUploadHandler = (postId) => {
        var currentTime = new Date().getTime();
        var imgId = currentTime + '-' + uuidv4() + '-' + selectedFileName.trim();
        var uploadTask = storageRef.child('images/posts/' + imgId).put(selectedFile);

        uploadTask.on('state_changed', function (snapshot) {

            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused');
                    break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    console.log('Upload is running');
                    break;
            }
        }, function (error) {
            // Handle unsuccessful uploads
        }, function () {

            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                console.log('File available at', downloadURL);
                //Update post with image data after upload to firebase
                database.collection(firebaseCollections.thewall).doc(postId).set({
                    image: {
                        id: imgId,
                        url: downloadURL
                    }
                }, { merge: true }).then(function () {
                    console.log("Finished updating post with image data in firebase db.");
                })
                    .catch(function (error) {
                        console.error("Error adding document: ", error);
                    });
            });
        });
    }


    return (
        <div className="AddNewPostForm">
            <div className="AddNewPostForm--Header">
                <p className="AddNewPostForm--Header--Title">Share Feedback</p>
                <AppDropdown className="AddNewPostForm--Visibility-Dropdown" defaultvalue={visibilityStatesArr[selectedPostVisibility]} headertitle="Post Visibility" items={visibilityStatesArr} darktone={true} alignright={true} style={{ fontSize: "1em" }} onSelect={onVisibilitySelect} activeindex={selectedPostVisibility} />
            </div>
            <div className="AddNewPostForm--Body">
                <div className="AddNewPostForm--Input-Container">
                    <Avatar name={account.name} round={true} textSizeRatio={2.2} size="36px" color="White" maxInitials={2} className="AppNavbar--Profile-Container--Avatar" />
                    {/* <RichTextEditor setEnteredPostText={setEnteredPostText}/> */}
                    <textarea value={enteredPostText} onChange={(e) => { setEnteredPostText(e.currentTarget.value) }} rows="3" placeholder="What's on your mind?" />
                </div>
                {selectedFilePreviewImgURL ? <img className="AddNewPostForm--Input-Container--SelectedFile-Preview-Img" src={selectedFilePreviewImgURL} alt="selected file preview" /> : null}
                <hr style={{ marginBottom: 0 }} />
                <div className="AddNewPostForm--Footer">
                    <div className="AddNewPostForm--Footer--Leftside">
                        <div className="AddNewPostForm--Type-Dropdown-Container">
                            <AppDropdown className="AddNewPostForm--Type-Dropdown" defaultvalue={postTypesArr[selectedPostType]} headertitle="Feedback Type" items={postTypesArr} darktone={false} alignright={true} style={{ fontSize: "1em", color: "#424242" }} onSelect={onTypeSelect} activeindex={selectedPostType} />
                        </div>
                        <Button className="App--primary-text-btn AddNewPostForm--Upload-Btn" onClick={selectFileHandler}>Upload Image</Button>
                        <input id="AddNewPostForm--ImageUpload" type="file" onChange={fileSelectedOnChangeHandler} style={{ display: 'none' }} />
                        {selectedFileLabel}
                    </div>
                    <div className="AddNewPostForm--Footer--Rightside">
                        <Button disabled={handleFormValidation()} className="App--secondary-text-btn" onClick={handleFormSubmission} >POST</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
